<template>
    <div
        role="button"
        class="tooltip-target"
        :aria-expanded="isOpen"
        :aria-label="ariaLabel"
        :tabindex="tabindex"
        @focusin="openNoOverlay($event)"
        @mouseover="openNoOverlay($event)"
        @mouseout="close($event, 'mouseout')"
        @focusout="close($event, 'focusout')"
        @click="openWithOverlay($event)"
    >
        <div
            class="overlay"
            @click.stop.prevent="close($event, 'overlay close')"
            :style="{ display: overlay ? 'block' : 'none' }"
        ></div>
        <div class="tooltip" @click.stop.prevent :style="{ display: isOpen ? 'block' : 'none' }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['aria-label', 'tabindex'],

        data: function () {
            return {
                isOpen: false,
                overlay: false
            };
        },

        methods: {
            openNoOverlay(e) {
                if (!this.isOpen) {
                    this.isOpen = true;
                    this.overlay = false;
                }
            },

            openWithOverlay(e) {
                this.isOpen = true;
                this.overlay = true;
            },

            close(e, message) {
                if (this.overlay && e.type === 'mouseout') {
                    return false;
                }
                this.isOpen = false;
                this.overlay = false;
            }
        }
    };
</script>
